import "./App.css";
// import { PersistGate } from "redux-persist/integration/react";
import "./services/registerInterceptor";
import store from "./store/store";
import MainNavigator from "./Components/Navigators/MainNavigator";
// import LoginScreen from "./Components/Views/AuthModule/LoginScreen";
import { Toaster } from "react-hot-toast";
import { Provider as StoreProvider } from "react-redux";
import { errorToast, successToast } from "./services/toast.service";
import { useEffect, useState } from "react";
import GoogleAuthScreen from "./Components/Views/AuthModule/GoogleAuthScreen";
import { BrowserRouter } from "react-router-dom";

function App() {
  // Demo toggle for Google Auth - in a real app this might come from an environment variable or API
  const [isGoogleAuthenticated, setIsGoogleAuthenticated] = useState(true);

  // Check if the user has already completed Google Auth
  useEffect(() => {
    const googleAuthToken = localStorage.getItem("google_auth_token");
    const googleRefreshToken = localStorage.getItem("google_refresh_token");

    if (googleAuthToken && googleRefreshToken) {
      setIsGoogleAuthenticated(true);
    }
  }, []);

  // Network monitoring component
  const NetworkStatus = () => {
    useEffect(() => {
      // Handler for offline status
      const handleOffline = () => {
        errorToast("Network connection not found");
      };

      const handleOnline = () => {
        successToast("Network connection restored");
      };

      // Add event listeners
      window.addEventListener("offline", handleOffline);
      window.addEventListener("online", handleOnline);

      // Cleanup event listeners
      return () => {
        window.removeEventListener("offline", handleOffline);
        window.removeEventListener("online", handleOnline);
      };
    }, []);

    return null;
  };

  return (
    <div className="App">
      <StoreProvider store={store}>
        {/* <PersistGate loading={null} persistor={persistor} > */}
        <Toaster position="top-right" />
        <BrowserRouter>
          {isGoogleAuthenticated ? (
            // Only show MainNavigator if Google authenticated
            <MainNavigator useExistingRouter={true} />
          ) : (
            // Otherwise show Google Auth screen as the entire app
            <GoogleAuthScreen
              onAuthSuccess={() => setIsGoogleAuthenticated(true)}
            />
          )}
        </BrowserRouter>
        <NetworkStatus />
        {/* </PersistGate> */}
      </StoreProvider>
    </div>
  );
}

// const AppRoute = () => {
//   const [authenticated, setAuthenticated] = useState(false);

//   if (authenticated) return <MainNavigator />;
//   else return <LoginScreen />;
// };

export default App;
